// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"af21d036","109":"ca4b4260","175":"4af5eee6","197":"e9d8b998","246":"2c4aa9e9","258":"adf338f5","273":"bb1fa052","386":"200b254c","467":"7b6917fd","488":"c22b383c","747":"c9e4dd97","757":"b2e20df8","785":"f87d74b2","848":"4993aa9f","925":"18087c0c"}[chunkId] + ".chunk.js";
};